/**
 * Legacy-Redirect: /shares → /splits
 *
 * Story 0.2: Ziel von /commissions auf die neue kanonische Route /splits
 * umgestellt, damit kein doppelter Redirect-Hop entsteht.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/shares')({
  beforeLoad: () => {
    throw redirect({ to: '/splits', replace: true })
  },
  component: () => null,
})
